import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import {
  SIGNIN_USER,
  SIGNOUT_USER,
  FETCH_USER
} from 'constants/ActionTypes';
import { showAuthMessage, userSignInSuccess, userSignOutSuccess } from 'actions/Auth';


function* signIn ({ payload }) {
  const { companyCode, username, password } = payload;

  try {
    if (!companyCode) throw ('appModule.companyCodeIsRequired')
    if (!username) throw ('appModule.usernameIsRequired')
    if (!password) throw ('appModule.passwordIsRequired')

    const signInUser = yield call(api.authApi.getToken, payload);

    if (signInUser.errorMessage) {
      yield put(showAuthMessage(signInUser.errorMessage, true));
    } else {
      localStorage.setItem('userId', signInUser.id);
      localStorage.setItem('token', signInUser.accessToken);
      yield put(userSignInSuccess(signInUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error.message || error));
  }
}

function* signOut () {
  const token = localStorage.getItem('token');
  yield call(api.authApi.signOut, token);

  localStorage.removeItem('userId');
  localStorage.removeItem('token');
  yield put (userSignOutSuccess());
}

function* getProfile () {
  try {
    const token = localStorage.getItem('token');
    const user = yield call(api.authApi.getProfile, token);

    if (user.errorMessage) {
      localStorage.removeItem('userId');
      localStorage.removeItem('token');
      yield put(userSignOutSuccess());
      yield put(showAuthMessage(user.errorMessage, true));
    } else {
      yield put(userSignInSuccess(user));
    }
  } catch (error) {
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    yield put(userSignOutSuccess());
    yield put(showAuthMessage(error.message || error));
  }
}

export function* signInUser () {
  yield takeEvery (SIGNIN_USER, signIn);
}

export function* signOutUser () {
  yield takeEvery (SIGNOUT_USER, signOut);
}

export function* fetchProfile () {
  yield takeEvery(FETCH_USER, getProfile);
}

export default function* rootSaga () {
  yield all ([
    fork (signInUser),
    fork (signOutUser),
    fork (fetchProfile)
  ]);
}


// WEBPACK FOOTER //
// ./sagas/Auth.js